var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"row"},[_c('progress-bar',{class:_vm.values.label ? 'col-7' : 'col-12',attrs:{"data":_vm.progressBarData,"small":true}}),(_vm.values.label)?_c('span',{staticClass:"col-5"},[_vm._v(_vm._s(_vm.values.total)+" "+_vm._s(_vm.values.label))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }